import type { JSONSchemaType } from "ajv";

import {
  OrbitCamera,
  Position,
  Sphere,
  Box,
  Grid,
  Mesh,
  Path,
} from "../three-d";
import { topicDataSchema } from "../topic-data";

export const orbitCameraSchema: JSONSchemaType<OrbitCamera> = {
  type: "object",
  properties: {
    type: { type: "string", enum: ["orbit"] },
    target: {
      type: "object",
      properties: {
        id: { type: "string" },
        mesh: { type: "string", enum: ["mesh", "path"] },
      },
      required: ["id", "mesh"],
    },
    zoom: {
      type: "object",
      properties: {
        min: { type: "number", nullable: true },
        max: { type: "number", nullable: true },
      },
    },
  },
  required: ["type", "zoom", "target"],
  additionalProperties: false,
};

export const cameraSchema = orbitCameraSchema;

export const pathSchema: JSONSchemaType<Path> = {
  type: "object",
  properties: {
    color: { type: "string" },
    lineWidth: { type: "number", nullable: true },
  },
  required: ["color"],
  additionalProperties: false,
};

export const positionSchema: JSONSchemaType<Position> = {
  type: "object",
  properties: {
    transformation: {
      type: "string",
      enum: ["lla_to_enu", null],
      nullable: true,
    },
    basePreset: {
      type: "string",
      enum: [
        "lat_lon_alt",
        "east_north_up",
        "north_east_down",
        "forward_right_up",
      ],
      nullable: true,
    },
    forward: { oneOf: [topicDataSchema, { type: "number" }] },
    forwardScale: { type: "number" },
    right: { oneOf: [topicDataSchema, { type: "number" }] },
    rightScale: { type: "number" },
    up: { oneOf: [topicDataSchema, { type: "number" }] },
    upScale: { type: "number" },
  },
  required: ["forward", "forwardScale", "right", "rightScale", "up", "upScale"],
  additionalProperties: false,
};

export const sphereSchema: JSONSchemaType<Sphere> = {
  type: "object",
  properties: {
    type: { type: "string", enum: ["sphere"] },
    color: { type: "string" },
    radius: { type: "number" },
  },
  required: ["type", "color", "radius"],
  additionalProperties: false,
};

export const boxSchema: JSONSchemaType<Box> = {
  type: "object",
  properties: {
    type: { type: "string", enum: ["box"] },
    color: { type: "string" },
    size: { type: "number" },
  },
  required: ["type", "color", "size"],
  additionalProperties: false,
};

export const gridSchema: JSONSchemaType<Grid> = {
  type: "object",
  properties: {
    color: { type: "string" },
    scale: { type: "number", nullable: true },
    verticalOffset: { type: "number", nullable: true },
  },
  required: ["color"],
  additionalProperties: false,
};

export const meshSchema: JSONSchemaType<Mesh> = {
  type: "object",
  oneOf: [sphereSchema, boxSchema],
  nullable: true,
};
